import React from 'react';
import ElegantResumePersonalInformation from './ElegantResumePersonalInformation';
import ElegantResumeSummary from "./ElegantResumeSummary";
import ElegantResumeHobbies from "./ElegantResumeHobbies";
import ElegantResumeCustom from "./ElegantResumeCustom";
import ElegantResumeEmployment from './ElegantResumeEmployment';
import ElegantResumeEducation from "./ElegantResumeEducation";
import ElegantResumeReference from "./ElegantResumeReference";
import ElegantResumeSkills from "./ElegantResumeSkills";
import ElegantResumeLanguage from "./ElegantResumeLanguage";

export default class ElegantResume extends React.Component {
    getAllOtherParts(){
        let otherForms = []
        for(let i = 0; i < this.props.resumeData.otherForms.length; i++){
            let form = this.props.resumeData.otherForms[i];
            switch(form.type){
                   case 'summary':
                       otherForms.push(<ElegantResumeSummary title={form.title} data={form.data} key={i}/>);
                       break;
                   case 'hobbies':
                       otherForms.push(<ElegantResumeHobbies title={form.title} data={form.data} key={i}/>);
                       break;
                   case 'custom':
                       otherForms.push(<ElegantResumeCustom title={form.title} data={form.data} key={i}/>);
                       break;
                   case 'employment':
                       otherForms.push(<ElegantResumeEmployment title={form.title} data={form.data} key={i}/>);
                       break;
                   case 'education':
                       otherForms.push(<ElegantResumeEducation title={form.title} data={form.data} key={i}/>);
                       break;
                   case 'references':
                       otherForms.push(<ElegantResumeReference title={form.title} data={form.data} key={i}/>);
                       break;
                   case 'skills':
                       otherForms.push(<ElegantResumeSkills title={form.title} data={form.data} key={i}/>);
                       break;
                   case 'languages':
					   otherForms.push(<ElegantResumeLanguage title={form.title} data={form.data} key={i}/>);
                default:
                // Do nothing;
            }
        }
        return otherForms;
    }
    render() { 
        return  <div data-v-5a80631c="" className="container">
			
            <ElegantResumePersonalInformation
                title={this.props.resumeData.personalDetailForm.title}
                data={this.props.resumeData.personalDetailForm.data}/>

		<div data-v-5a80631c="" className="section-right">
            {this.getAllOtherParts()}
            </div>
    </div>;
    }
}